import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-46 «Ролі і доступи» (F-032). Тека с этим файлом — и есть
// регистрация (`../registry.ts`): пункт «Ролі і доступи» раздела «СИСТЕМА» оживает
// вместе с ней (решение 028). Пункт виден только тому, у кого «Право видавати права»;
// прямой адрес без права — отказ сервера без данных.
export const meta: SurfaceMeta = {
  code: "S-46",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s46_title");
  },
  path: "/s-46",
};
